import React from 'react';

import {
  BenefitStartDateField,
  BUHBlockedField,
  CodeExtField,
  CodeExtSecondaryField,
  CodeField,
  CodeImpField,
  CodeImpSecondaryField,
  EmployerField,
  FinancialCostCenterField,
  InvoiceCreditBlockedField,
  InvoiceDebitBlockedField,
  NameField,
  NameShortField,
  ParentCostCenterField,
  PlanningExportField,
  ValidFromField,
  ValidToField,
  VATDeductibleField
} from '../fields/SubEntityFields';

const SubEntitySection: React.FC = () => {
  return (
    <>
      <CodeField />
      <NameField />
      <NameShortField />
      <CodeExtField />
      <CodeExtSecondaryField />
      <CodeImpField />
      <CodeImpSecondaryField />
      <BenefitStartDateField />
      <FinancialCostCenterField />
      <ParentCostCenterField />
      <BUHBlockedField />
      <PlanningExportField />
      <VATDeductibleField />
      <InvoiceDebitBlockedField />
      <InvoiceCreditBlockedField />
      <ValidFromField />
      <ValidToField />
      <EmployerField />
    </>
  );
};

export default SubEntitySection;
